export default function SuccessPage() {
    return (
        <section className="success-section" style={{ padding: '70px' }}>
            <div>
                <h2 className="title">You have successfully submitted the form!</h2>
                <p>Thank you for reaching out to us. Your submission has been received successfully. Our team will review your message and get back to you as soon as possible.</p>
                <p>We appreciate your interest in our services and look forward to assisting you!</p>
                <p><b>*If you do not see a reply from us, please check your spam or junk folder*</b></p>
            </div>
        </section>
    );
}